import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Grid, Link, Typography } from "@material-ui/core";
import { useStyles } from "./dashboardStyles";

function ClaimProcess({
  classes: { performanceCardsClaims, spacing, link },
  handleStaticPageClick,
}) {
  return (
    <Grid item md={4}>
      <Box key={"how-to-claim"} className={performanceCardsClaims}>
        <Box className={`${spacing}`}>
          <Typography variant={"subtitle2"}>How To Claim</Typography>
        </Box>
        <Box className={spacing}>
          <Typography variant={"body2"}>
            Submitting is as easy as a-b-c!
          </Typography>
          <br />
          <Box>
            <Typography variant={"body2"}>
              1. You need to pay a nominal claim processing fee (not applicable for mobile extended warranty plan) according to the plan
              conditions.
            </Typography>
            <br />
            <Typography variant={"body2"}>
              2. Take your phone to any Vivo-authorised service centre near you.
            </Typography>
            <br />
            <Typography variant={"body2"}>
              3. The service centre will assess the damage and submit a claim on
              your behalf. (if required)
            </Typography>
            <br />
          </Box>
          <Box
            className={link}
            onClick={() =>
              handleStaticPageClick("https://garantie.in/privacy-policy/", "Privacy Policy")
            }
          >
            <Typography variant="body2">Privacy Policy</Typography>
          </Box>
          <Box
            mt={3}
            className={link}
            onClick={() =>
              handleStaticPageClick( "https://garantie.in/terms-conditions/", "Terms & Conditions")
            }
          >
            <Typography variant="body2">Terms &amp; Conditions</Typography>
          </Box>
          <Box
            mt={3}
            className={link}
            onClick={() =>
              handleStaticPageClick(
              "https://garantie.in/cancellation-refund/",
                "Cancellation & Refund Policy"
              )
            }
          >
            <Typography variant="body2">
              Cancellation &amp; Refund Policy
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}

export default withStyles(useStyles, { withTheme: true })(ClaimProcess);
